import { render, staticRenderFns } from "./update_des.vue?vue&type=template&id=247df465&scoped=true&"
import script from "./update_des.vue?vue&type=script&lang=js&"
export * from "./update_des.vue?vue&type=script&lang=js&"
import style0 from "./update_des.vue?vue&type=style&index=0&id=247df465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247df465",
  null
  
)

export default component.exports